import { translateEnRu } from "./Translate";
import { getRandomInt } from "./Slider";
const changeQuotes = document.querySelector(".change-quote");
const quote = document.querySelector(".quote");
const author = document.querySelector(".author");
let langCurrent = translateEnRu();
console.log(langCurrent);
async function getQuotes(langCurrent) {
  let quotes;
  // if (langCurrent == "en") {
  console.log(langCurrent);
  quotes = "data.json";
  console.log("getQuotes click");
  const res = await fetch(quotes);
  const data = await res.json();
  console.log(data);
  let random = data[getRandomInt(0, data.length - 1)];
  quote.textContent = random.text;
  author.textContent = random.author;
  console.log(data);
  //}
}
getQuotes(langCurrent);
export { getQuotes };
